import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import "../FinderBase/FinderBaseV2";
//import FilterPanel = require("../../moreCore/UI/FilterPanel/FilterPanel");
import "../../moreCore/UI/FilterPanel/FilterPanel";
import { TodoForm, TodoListTypes } from "../_loadingHelpers/TodoList"; 
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';

class TodoListFinder extends compose(FinderBaseV2) {

    private _tableFormatter(cell: StaticTable.StaticTableCell<TodoListTypes.TodoListData>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {
            case "group":
                let ico: HTMLElement;
                if (entity.Classname === "todo_member_evis_user") ico = this.createFontawesomeIcon("fas fa-user w3-text-green");
                if (entity.Classname === "todo_member_associate_grouped") ico = this.createFontawesomeIcon("fas fa-users w3-text-blue-gray");
                if (ico) {
                    this.UiModder.domConstruct.place(ico, node);
                }
                this.UiModder.domClass.add(node, "w3-center");
                return true;
                break;
            case "dueDate":
                let dateNow = new Date();
                let valueDate = new Date(value);
                if (dateNow.getTime() > valueDate.getTime() && !entity.ref_todo_appointment.is_finished) this.UiModder.domClass.add(node, "w3-text-red");

                else if (entity.ref_todo_appointment.is_finished) {
                    this.UiModder.domClass.add(cell.tableRow.node, "strike secondaryText");
                }
                break;
            case "isFinished":
                let canFinish = entity.is_allowed_finishing;
                let currentValue = entity.ref_todo_appointment.is_finished;
                let checkBox = new CheckBox();
                checkBox.on("click", lang.hitch(this, this._onClick_IsFinished));
                checkBox.on("change", lang.hitch(this, this._onChange_Checkbox, checkBox, entity))
                checkBox.setValue(currentValue, true);
                checkBox.setReadonly(!canFinish || currentValue);
                checkBox.placeAt(node);
                return true;
                break;
            default:
                node.innerHTML = value;
        }

        return false;
    }

    private _onClick_IsFinished(evt: Event) {
        evt.stopPropagation();
    }

    private _onChange_Checkbox(checkBox: MdsLax<InstanceType<typeof CheckBox>>, entity: TodoListTypes.TodoListData, evt) {
        if (evt) {
            entity.ref_todo_appointment.is_finished = evt;
            checkBox.setReadonly(true);
            this._finishTodo(entity);
        }
    }

    private _finishTodo(entity: TodoListTypes.TodoListData) {
        console.log(entity);

        this.RequestManager.callfunction("Webtool_API_TodoList_SetTodoFinished", { entity }, lang.hitch(this, this._onFinishTodoResponse), lang.hitch(this, this._onFinishTodoError))
    }

    private _onFinishTodoResponse(response) {
        this.showToast("TodoList_Success_FinishTodo", "fas fa-check");
        this.reload();
    }

    private _onFinishTodoError(error) {
        console.error(error);
        this.showToast("TodoList_Error_FinishTodo", "fas fa-exclamation-triangle");
        this.reload();
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<TodoListTypes.TodoListData>) {
        this.showTodoAppointment(row.rowGroup.entity);
    }

    private showTodoAppointment(data: TodoListTypes.TodoListData) {

        let todoForm = new TodoForm();
        if (this.isEmbeddedInTab) {
            this.requestNewTabbedContent({
                name: data.ref_todo_appointment.ID,
                enableClosing: true,
                label: data.ref_todo_appointment.gDisp_1,
                sidebarEntryName: data.ref_todo_appointment.ID,
                widget: todoForm,
                coloration: data.ref_todo_appointment.tmp_status_color_hex,
                groupLabel: data.ref_todo_appointment.gDisp_1,
                iconclass: "fas fa-clipboard-list"
            }, true);
        }

        todoForm.loadData(data.ref_todo_appointment.ID);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinder(
            "TodoList/GetTodoFinderConfig",
            "TodoList/GetTodoFinderList",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this._tableFormatter),
            null
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any); 
    }
}

export default mdsWidget(TodoListFinder);